export class RegistrationDTO {

  public email: string = null;
  public phone: string = null;
  public phonePrefix: string = null;
  public emailVerified = false;
  public phoneVerified = false;
  public gclid: string = null;
  public analyticsClientId = false;
  public accountId: string = null;
  public secretId: string = null;
  public firstName: string = null;
  public lastName: string = null;
  public street: string = null;
  public apartment: string = null;
  public city: string = null;
  public region: string = null;
  public postalCode: string = null;
  public countryIsoCode: string = null;


  public constructor(json: any = null) {
    if(json != null) {
      for(let property in json) {
        this[property] = json[property];
      }
    }
  }


}
